import { create } from "zustand";

interface MeetingReportsStateValues {
  isFetching: boolean;
}

interface MeetingReportsState extends MeetingReportsStateValues {
  setIsFetching: (isFetching: boolean) => void;
}

const DEFAULT_STATE: MeetingReportsStateValues = {
  isFetching: false,
};

const useMeetingReportsStore = create<MeetingReportsState>((set) => ({
  ...DEFAULT_STATE,
  setIsFetching: (isFetching) => set({ isFetching }),
}));

export default useMeetingReportsStore;
